import { combineReducers } from 'redux';
import tarif from './tarif.reducer.js';

const reducer = combineReducers({
    tarif,
});

export default reducer;
